import Wrapper from "../../../layout/Wrapper";
import UserPermissionComponent from "../../../screens/settings/user-permission";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "User Permission",
	description: "",
};

export default function UserPermission() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<UserPermissionComponent />
		</Wrapper>
	);
}